import React from 'react'

export default function HeadingBanner({title}) {
  return (
    <section>
      <div className='head_bn'>
      <img src= '/assets/images/forall3.png'  />
        {/* <div className='sdd position-absolute top-0' style={{backdropFilter:'brightness(0.7)',width:'100%',height:'100%'}}>
        </div> */}
        <div className='position-absolute top-50 start-50 text-center translate-middle'>
          <h2 className=''>{title}</h2>
        </div>
      </div>
    </section>
  )
}

export function HeadingBanner2({image}) {
  return (
    // <section>
    <>
      <div className='head_bn2'>
      {/* <img src= '/assets/images/bannerimg.png'  /> */}
        <img src= {image}  />
        <div className='sdd position-absolute top-0 bottom-0' >
        </div>
        <div className='position-absolute top-50 start-50 text-center translate-middle'>
        </div>
      </div>
      </>
    // </section>
  )
}

export function HeadingBanner3({image}) {
  return (
    <section>
      <div className='head_bn2'>
      {/* <img src= '/assets/images/aboutimg.png'  /> */}
       <img src= {image}  />
        <div className='sdd position-absolute top-0' >
        </div>
        <div className='position-absolute top-50 start-50 text-center translate-middle'>
        </div>
      </div>
    </section>
  )
}

export function HeadingBanner4({image}) {
  return (
    <section>
      <div className='head_bn2'>
      {/* <img src= '/assets/images/contactbanner.png'  /> */}
        <img src= {image}  />
        <div className='sdd position-absolute top-0' >
        </div>
        <div className='position-absolute top-50 start-50 text-center translate-middle'>
        </div>
      </div>
    </section>
  )
}

export function HeadingBanner5({image}) {
  return (
    <section>
      <div className='head_bn2'>
      {/* <img src= '/assets/images/terms.png'  /> */}
        <img src= {image}  />
        <div className='sdd position-absolute top-0' >
        </div>
         <div className='position-absolute top-50 start-50 text-center translate-middle'>

        </div>
      </div>
    </section>
  )
}

export function HeadingBanner6({image}) {
  return (
    <section>
      <div className='head_bn2'>
      {/* <img src= '/assets/images/refund.png'  /> */}
       <img src= {image}  />
        <div className='sdd position-absolute top-0' >
        </div>
         <div className='position-absolute top-50 start-50 text-center translate-middle'>

        </div>
      </div>
    </section>
  )
}

export function HeadingBanner7({image}) {
  return (
    <section>
      <div className='head_bn2'>
      {/* <img src= '/assets/images/privacy.png'  /> */}
        <img src= {image}  />
        <div className='sdd position-absolute top-0' >
        </div>
         <div className='position-absolute top-50 start-50 text-center translate-middle'>

        </div>
      </div>
    </section>
  )
}

export function HeadingBannerCart({image}) {
  return (
    <section>
      <div className='head_bn2'>
      {/* <img src= '/assets/images/cart.png'  /> */}
        <img src= {image}  />
        <div className='sdd position-absolute top-0' >
        </div>
         <div className='position-absolute top-50 start-50 text-center translate-middle'>

        </div>
      </div>
    </section>
  )
}

export function HeadingBannerDashboard({image}) {
  return (
    <section>
      <div className='head_bn2'>
      {/* <img src= '/assets/images/dashboard.png'  /> */}
       <img src= {image}  />
        <div className='sdd position-absolute top-0' >
        </div>
         <div className='position-absolute top-50 start-50 text-center translate-middle'>

        </div>
      </div>
    </section>
  )
}
